// extracted by mini-css-extract-plugin
module.exports = {"OtherProjectsHeading":"OtherProjects_OtherProjectsHeading__1YyBR","OtherProjectsGrid":"OtherProjects_OtherProjectsGrid__2z-mJ","ShowMoreBtn":"OtherProjects_ShowMoreBtn__20p6K"};